import { MutationTree } from "vuex";
import { StatisticState } from "./types";

export const mutations: MutationTree<StatisticState> = {
  setMailNotifyStaticGroup: (state, data) => {
    state.mailNotifyStatisticGroup = data;
  },
  setMailNotifyStaticDetail: (state, data) => {
    state.mailNotifyStaticDetail = data;
  },
  pushMailNotifyStaticDetail: (state, data) => {
    state.mailNotifyStaticDetail = state.mailNotifyStaticDetail.concat(data);
  },
  setMailNotifyStaticDetailFlag: (state, data) => {
    state.mailNotifyStaticDetailFlag = data;
  },
};
